/**
 * Factory for creating safe selectors for lazily-injected Redux slices.
 *
 * Encapsulates the slice key and fallback to initialState so that
 * components never touch state['key'] directly and never need to
 * handle undefined slices themselves.
 */
const createDomainSelectors = (sliceKey, initialState) => {
  const selectSlice = (state) => state[sliceKey] ?? initialState

  const selectField = (field) => (state) => selectSlice(state)[field]

  const selectFields = (...fields) => (state) => {
    const slice = selectSlice(state)
    const result = {}
    for (let i = 0; i < fields.length; i++) {
      result[fields[i]] = slice[fields[i]]
    }
    return result
  }

  return { selectSlice, selectField, selectFields, sliceKey }
}

export default createDomainSelectors
